import { Component, OnInit } from '@angular/core';
import { HeaderService } from 'src/app/core/services';

@Component({
  selector: 'ic-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  public screenWidth: number;
  public showMenu = false;

  constructor(private readonly headerService: HeaderService) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;

    this.headerService.visibility$.subscribe(
      (visibility) => (this.showMenu = visibility)
    );
  }
}
